import { adminHttpClient } from '../../commons/adminHttpClient'

export type FamilyMemberInsurancePolicy = {
  id: string
  familyMemberId: string
  firstName: string
  lastName: string
  policyName: string
  startDate: Date
  endDate: Date
  isCoveredForTheFullYear: boolean
}

const getFamilyMemberInsurancePolicies = (year: string): Promise<FamilyMemberInsurancePolicy[]> =>
  adminHttpClient.get(`Expenses/FamilyMemberInsurancePolicies/${year}`)

export default getFamilyMemberInsurancePolicies
